<template>
  <div class="root">
    <el-container class="wrapper" ref="wrapper">
      <el-header height="50px" class="page-header">
        <el-form :model="formData" :inline="true" size="mini" style="margin-top: 10px;">
          <el-form-item label="文件名:">
            <el-input v-model="formData.fileName"></el-input>
          </el-form-item>
          <el-form-item style="float: right; margin-top: -1px;">
            <button class="ioc-button i-mini i-success" @click="handleSearch">搜索</button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main class="table-main">
        <div class="main-weapper" ref="body">
          <div style="margin-bottom: 10px">
            <el-button
              type="primary"
              size="mini"
              @click="showExport"
            >上传
            </el-button>
          </div>
          <el-table
            border
            stripe
            :header-cell-class-name="cellClass"
            :header-cell-style="{ backgroundColor: '#F4F8FB' }"
            :data="tableData"
            :height="tableHeight"
            header-row-class-name="table-header-row"
            v-loading="loading"
            v-if="tableHeight">
            <el-table-column prop="fileName" label="文件名"></el-table-column>
            <el-table-column prop="updateInstructions" label="更新说明"></el-table-column>
            <el-table-column prop="operator" label="操作人" width="200px" align="left"></el-table-column>
            <el-table-column prop="status" label="状态" width="220px" align="left"></el-table-column>
            <el-table-column prop="startTime" label="上传时间" width="160px" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.uploadTime}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120px" align="center">
              <template slot-scope="scope">  <!----><!--@click="downLoadRequest(scope.row.spuId, scope.row.fileId, scope.row.fileName)-->
                <el-button type="text" size="mini" @click="downLoadFile(scope.row.filePath, scope.row.fileName)" v-if="scope.row.status === '成功'">下载</el-button>
                <el-button type="text" size="mini" disabled v-else>下载</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 15px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNum"
              :page-sizes="[30, 60, 120]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
            </el-pagination>
          </div>
        </div>

        <upload :visible.sync="dialogFormVisible" v-if="dialogFormVisible" @success="handleSearch"></upload>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {getToken} from '@/utils/auth'
import moment from 'moment'
import pagePathMixin from '@/utils/page-path-mixin'
import upload from './upload'
export default {
  components: { upload },
  mixins: [pagePathMixin],
  data() {
    return {
      formData: {},
      tableData: [],
      loading: false,
      tableHeight: 0,
      page: {
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      errorMsg: '',
      // 上传
      dialogFormVisible: false
    }
  },
  created(){
    if(this.fileType==1){
      this.$route.meta.title = 'bom表导入'
    }else{
      this.$route.meta.title = '信息表导入'
    }
  },
  computed: {
    fileType() {
      return this.$route.query.fileType
    }
  },
  mounted() {
    this.tableHeight = this.$refs['wrapper'].$el.offsetHeight - 165;
    this.init();
  },
  methods: {
    cellClass(row){
      if (row.columnIndex === 0) {
        return 'disabledCheck'
      }
    },
    downLoadFile(path, name) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(_=>{
        this.downLoad(path, name)
        loading.close();
      },300)
    },
    downLoad(path, name) {
      let url = path;
      let fileName = name;
      var xhr = new XMLHttpRequest();
      xhr.open("GET",url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },
    downLoadRequest(spuId, fileId, fileName) {
      this.$q.newProduct.downLoadExcuseExcel({
        data: {
          fileId: fileId,
          spuId: spuId
        },
        options: {
          responseType: 'blob'
        }
      })
        .then(res=>{
          console.log(res)
          this.blobDownload(res, fileName)
        }).catch(e=>{
          this.$message.error(e.message)
      })
    },
    blobDownload(res,fileName) {
      let objectUrl = window.URL.createObjectURL(res);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName;
      a.click()
      a.remove();
    },
    // pagination
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.init();
    },
    handleSearch() {
      this.page.pageNum = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.formData,
          fileType: this.fileType
        },
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      };
      this.$q.newProduct.queryUploadHistory({data})
      .then(res=>{
        if(res.code == 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }else{
          this.tableData = [];
        }
      })
      .finally(_=>{
        this.loading = false;
      })
    },
    showExport() {
      this.fileList = [];
      this.dialogFormVisible = true;
/*      let filename = this.$route.query.fileName;
      filename = filename.substring(0, filename.lastIndexOf('.'))
      this.titleName = filename + '批量维护';*/
    },
  }
}
</script>

<style lang="stylus" scoped>
  .root
    height 100%
    padding 5px
    box-sizing border-box
  .wrapper
    border-radius 4px
    height 100%
    width 100%
  >>> .el-header
    background #ffffff
    margin-bottom 5px !important
    border-radius 4px
  >>> .el-main
    padding 10px
    padding-top 0
    background #ffffff
    border-radius 4px
  .main-weapper
    margin-top 10px
</style>
